import { Component, inject } from '@angular/core';
import { ListViewProviderDirective } from '@ntap/core';
import { PrimeNGButtonOpenItemViewActionComponent } from '@ntap/primeng';
import { map } from 'rxjs';

@Component({
  selector: 'app-razmjesti-nize-action',
  templateUrl: '../../../shared/components/actions/common-action-template.html',
  styleUrls: ['./razmjesti-nize-action.component.scss']
})
export class RazmjestiNizeActionComponent extends PrimeNGButtonOpenItemViewActionComponent {
  listViewProvider = inject(ListViewProviderDirective);

  protected override initDisabledObservable(): void {
    this.isDisabled$ = this.listViewProvider.selectedItems$.pipe(
      map((selectedItems) => {
        return (
          selectedItems.length < 1 ||
          selectedItems.some((i) => {
            const item = i as any;
            const itemType = item['$itemType'];
            return (i as any)[itemType + '~rezidualni_podaci'];
          })
        );
      })
    );
  }
}
